import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { Router } from "@angular/router";
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { CookiesService } from '../../shared/services/storage/cookies.service';
import { ActivatedRoute } from '@angular/router';
import { EesDesService } from '../../shared/services/ees-des.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [WebServiceService, LocalStorageService, CookiesService,EesDesService]
})

export class LoginComponent implements OnInit {
  message = 'Dear Users, Please note that our server will be on regular maintenance from 00:00 Hours on May 21st, 2023 to 09:00 Hours on May 21st, 2023. Please plan your work accordingly.  Thanks';
  is_vendor_login:boolean=false;
  responseData: any = {}
  baseurl: string = "";
  userEmail: any = '';
  password: any = '';
  userNewEmail: any = '';
  isLoading: boolean = false;
  forgotPasswordInput: boolean = false;
  disableButton: boolean = false;
  year: any = new Date().getFullYear();
  rememberMe: boolean = false;
  counter: number = 0;
  show:any='0';
company_data:any={}
getParamList:any=[];
getKeysList:any=[];
isSSO:boolean=false;
isSocialLogin:boolean=false
userType:any = '2'
msLoginData:any={}
  constructor(public webService: WebServiceService,
    private router: Router,
    private toasterService: ToasterService,
    public _localStorageService: LocalStorageService,
    private titleService: Title,
    private _cookieService: CookiesService,
    private route: ActivatedRoute,public eesdesService:EesDesService,
    private activatedRoute: ActivatedRoute


  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      let keys:any=[];
      keys=Object.keys(params)?Object.keys(params):[]
      // console.log(keys)
      if(keys.length>0)
      {
      this.getKeysList=keys?keys:[]
      if((this.getKeysList.indexOf("c")>-1))
      {
      this.isSSO=true;
      // console.log(this.getKeysList);
      }
      this.getParamList.push(params);
      // console.log(params)
      // console.log(this.getParamList); // Print the parameter to the console.
      }
  });
  }
  source_data:any={type:'NORMAL',data:''}
  ngOnInit() {
    this.msLoginData=sessionStorage.getItem('claims')?sessionStorage.getItem('claims'):''
    if(this.msLoginData!='' && this.msLoginData!=null)
    {
      this.msLoginData=JSON.parse(this.msLoginData)
      this.isSSO=true
      this.isSocialLogin=true
    }
    this.showIssue(false);
    this.showSSO(this.isSSO);
    let value = location.href;
    let test :any= value.split('=')?value.split('='):[];
    console.log(test);
    if(Array.isArray(test) && !this.isSSO)
    {
      if(test.length>1)
      {
        let enc_data: string = this.route.snapshot.queryParamMap.get('data');
        console.log(enc_data);
        console.log(this.isSSO);
this.source_data.data=enc_data?enc_data:''
this.source_data.type='MAIL'
      }
    }
    this.getLoginData(window.location.hostname);
    this.checkAuth();
    let temp = this._localStorageService.getUserId() ? this._localStorageService.getUserId() : ''
    if (temp != "" && temp != undefined && temp != '') {
      // this.toasterService.pop("info", "Info", "Already login");
      this.getCompanySetUpData();

    }
    if(!this.isSSO)
    {
    if (this._cookieService.getrememberMe() == '1') {
      this.userEmail = (this._cookieService.getUserName())
      this.password = (atob(this._cookieService.getPassword()));
      this.rememberMe = true;
    } else {
      this.userEmail = "";
      this.password = '';
      this.rememberMe = false;
    }
  }
    this.titleService.setTitle("Login");
    if (!this.webService.isOnline()) {
      this.toasterService.pop("error", "Error", "Internet is not working");
      return false;
    }
    this.validateUser();
    document.getElementById("base-div").style.paddingTop = "0px";
    document.getElementById("base-div").style.marginLeft = "0px";
  }
  getLoginBackground()
  {
    this.title='Login to your TYASuite';
    this.background_image="https://d38cf3wt06n6q6.cloudfront.net/tyasuitefront/images/login-bg.png";
    this.logo="https://d38cf3wt06n6q6.cloudfront.net/tyasuitefront/images/white-logo.png"
  }
  title:any='Login to your TYASuite';
  background_image:any='';
  logo:any='';
  url_host:any=window.location.hostname=='localhost'?'ad.intelaccounts.in':window.location.hostname;

  getLoginData(url)
  {
    let requestObj = {
      "url_host":(url=='localhost'||url==''||url==undefined)?'ad.intelaccounts.in':window.location.hostname,
    }
       if(this.background_image!='')
    {
      return;
    }
    this.webService.commonPostMethod("Companies/view_client_setup", requestObj).
      subscribe(
        data => {
          if (data.status) {
            if(!Array.isArray(data.response))
            {
            this.title=data.response.title?data.response.title:'';
            // this.title='Login to your TYASuite.'
            this.background_image=data.response.background_image?data.response.background_image:''
            this.url_host=data.response.url_host?data.response.url_host:'';
            this.logo=data.response.logo?data.response.logo:'';
            }
            else
            {
              this.getLoginBackground()

            }
          }
          else {
            this.getLoginBackground()
          }

        },
        error => {
          this.getLoginBackground()

        }
      );
  }
  getObjectKeyIndex(obj, keyToFind) {
    var i = 0, key;

    for (key in obj) {
        if (key == keyToFind) {
            return i;
        }

        i++;
    }

    return -1;
}
  urlList: any = [];
  ssoText:any=' We are fetching your Activities ...'
  checkAuth() {
    if (this._localStorageService.getUserId() == undefined ||
      this._localStorageService.getUserId() == null) {
      if(this.getParamList.length==1)
      {
        if(this.isSSO)
        {
          this.isSSO=true;
          let d:any=(this.getParamList[0].c?this.getParamList[0].c:{email:'',password:''})
          if(d.indexOf(" ")>-1)
          {
            d=d.replace(/ /g,"+");
          }
          d=this.webService.get('',d,'1')
          // console.log(d);
          // console.log(this.getParamList);
          this.userEmail=d.email?d.email:'';
          this.password=d.password?d.password:'';
          this.login('SSO');
        }
      }
      if(this.isSocialLogin)
      {
        this.userEmail=this.msLoginData.preferred_username?this.msLoginData.preferred_username:'';
          this.password='';
          this.login('SSO');
      }
    }
    else {
      this.getCompanySetUpData();
    }
  }

  validateUser() {
    if (this._localStorageService.getUserId() != "" && this._localStorageService.getUserId() != undefined) {
      // this.toasterService.pop("info", "Info", "Already login");
      this.getCompanySetUpData();
    }
  }
  resetSSO()
  {
    this.isSSO=false;
    this.ssoText=''
    window.sessionStorage.clear()
    this.webService.redirectURL('/login');
  }
  login(type) {
    if (this.userEmail == '' || this.userEmail == undefined) {
      if(this.isSSO || this.isSocialLogin)
      {
      this.ssoText="Login Credential is invalid"
      }
      this.toasterService.pop("error", "Error", "Enter email id");
      return false;
    }
    if (this.password == '' || this.password == undefined) {
      if(this.isSSO && !this.isSocialLogin)
      {
      this.ssoText="Login Credential is invalid"
      }
      if(!this.isSocialLogin)
      {
      this.toasterService.pop("error", "Error", "Enter password");
      return false;
      }
    }
    this.isLoading = true
    let requestObj = {
      is_sso:type=='SSO'?'1':'0',
      "email": this.userEmail,
      "password":(this.eesdesService.set(this.password,'is_login_psw')?this.eesdesService.set(this.password,'is_login_psw'):'')
    }

    // console.log(requestObj)
    let url:any='';
    if(this.is_vendor_login)
    {
      url='/Vendor_management/loginVendor';
    }
    else
    {
      url='/login/ajax_login';
    }
    if(this.isSocialLogin)
    {
      delete requestObj['is_sso']
      requestObj['social_login']='1'
      requestObj['password']=''
      requestObj['company_id']='0'
      requestObj['email']=(this.eesdesService.set(this.userEmail,'is_login_psw')?this.eesdesService.set(this.userEmail,'is_login_psw'):'')
      url='/login/social_login';
    }
    this.webService.commonPostMethod(url, requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            this.responseData = data;
            if(data.message!='' && data.message!=undefined)
            {
              this.toasterService.pop('success', 'Success',data.message);

            }
            if (this.responseData.user.role != 'vendor' && !this.is_vendor_login) {
              this.responseData.user.enable_mfa = this.responseData.user.enable_mfa ? this.responseData.user.enable_mfa : "0";
              this.showOtp = this.responseData.user.enable_mfa=='1' ? true : false;
              this.user_id = this.responseData.user.id;
              if(this.responseData.user.enable_mfa!="1") {
                this.setUserVariables();
              }
            } else {
              this.setUserVariables();
            }
          } else {
            window.sessionStorage.clear()
            this.toasterService.pop('error', 'Error', data.message);
            this.isLoading = false;
            if(this.isSSO)
            {
            this.ssoText="Login Credential is invalid"
            }
          }
          this.isLoading = false;

        }, error => {
           window.sessionStorage.clear()
          this.toasterService.pop('error', 'Error','Something Went Wrong');
          this.isLoading=false;
          this.showIssue(false);
          this.showSSO(false)
          window.sessionStorage.clear()
          this.isSocialLogin=false
          this.isSSO=false
          this.msLoginData={}
        }
      );
  }

  setUserVariables() {
    localStorage.setItem('is_enc_on',this.eesdesService.set('1','is_enc_on'));
    localStorage.setItem('is_vendor_login',this.eesdesService.set(this.is_vendor_login?'1':'0'));
    localStorage.setItem("user_data", this.eesdesService.set(JSON.stringify(this.responseData.user)));
    this.isLoading = false;
    localStorage.setItem("emp_role", this.eesdesService.set(this.responseData.user.role));

    if (this.responseData.user.role != 'vendor' && !this.is_vendor_login) {
      localStorage.setItem("ven_role", this.eesdesService.set(""));

      this.getUserDetails(this.responseData.user.id);
      // this.getUserDetailsForDepartment(this.responseData.user.id)
    }
    if (this.responseData.user.role == 'vendor' && this.is_vendor_login) {
      localStorage.setItem("ven_role", this.eesdesService.set("vendor"));
      localStorage.setItem("emp_role", this.eesdesService.set("vendor"));

      this.getVendorDetails(this.responseData.user.id);
    }
    this._cookieService.setUserName(this.userEmail);
    this._cookieService.setPassword(btoa(this.password));
    this._cookieService.setrememberMe(this.rememberMe?'1':'0');
    this.setHttpCookie({"action":"set",
    "cookie_name": "accesstoken",
    "cookie_value": this.eesdesService.set(this.userEmail,'accesstoken'),
    "expire": "72000"})
    this.setHttpCookie({"action":"set",
    "cookie_name": "accesskey",
    "cookie_value": this.eesdesService.set(btoa(this.password),'accesskey'),
    "expire": "72000"})
    this.setHttpCookie({"action":"set",
    "cookie_name": "accessrem",
    "cookie_value": this.eesdesService.set(this.rememberMe?'1':'0','accessrem'),
    "expire": "72000"})
    // this.userLogin();
  }


  empDetails: any;
  getUserDetails(id) {
    let requestObj = {
      "emp_id": id == undefined || id == null ? 0 : id,
      "company_id":'0'
    }
    if(this.isSocialLogin)
    {
      requestObj['social_login']='1'
    }

    //employees/ajax_getsingemp
    //employees/ajax_getsingemp_companies_details
    this.webService.commonPostMethod('employees/ajax_getsingemp_companies_details', requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            this.empDetails = data;
            if (this.empDetails.empdata != undefined && this.empDetails.empdata != '') {


              if (this.empDetails.empdata.companies.length > 1) {
                this.webService.redirectURL('/my-companies')

              }
              else {
                if (this.empDetails.empdata) {
                  if (this.empDetails.empdata.companies) {
                    for (let j of this.empDetails.empdata.companies) {
                      if (j.employee_id == id) {
                        this.empDetails.empdata.employee_role = j.employee_role;
                        this.empDetails.empdata.employee_code = j.employee_code;
                        this.empDetails.empdata.company_id = j.company_id;
                        this.empDetails.empdata.company_title = j.company_title;
                        this.empDetails.empdata.company_code = j.company_code?j.company_code:'';

                        this.empDetails.empdata.company_logo = j.company_logo;
                        j.company_setup = j.company_setup ? j.company_setup : {};
                        this.empDetails.empdata.company_theme = j.company_theme;
                        this.empDetails.empdata.company_theme_text = j.company_theme_text;
                        this.empDetails.empdata.allow_multiple_login=j.allow_multiple_login?j.allow_multiple_login:'0'
                        // localStorage.setItem("company_setup", JSON.stringify(j.company_setup));
                        // j.company_setup.MINUTES_UNITL_AUTO_LOGOUT= j.company_setup.MINUTES_UNITL_AUTO_LOGOUT? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                        // localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',j.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
                        // localStorage.setItem("department_id", j.department?j.department:'');
                        // localStorage.setItem("department_name", j.department_name?j.department_name:'');
                        // localStorage.setItem("profile_image", j.profile_image?j.profile_image:'');


                      }
                    }
                  }
                }
                // localStorage.setItem("company_id", this.eesdesService.set(this.empDetails.empdata.company_id));
                // localStorage.setItem("emp_role", this.eesdesService.set(this.empDetails.empdata.employee_role));
                // localStorage.setItem("company_title", this.eesdesService.set(this.empDetails.empdata.company_title));
                // localStorage.setItem("company_code", this.eesdesService.set(this.empDetails.empdata.company_code));

                // localStorage.setItem("company_logo", this.eesdesService.set(this.empDetails.empdata.company_logo));
                // localStorage.setItem("employee_code", this.eesdesService.set(this.empDetails.empdata.employee_code));
                // localStorage.setItem("company_theme", this.eesdesService.set(this.empDetails.empdata.company_theme));
                // localStorage.setItem("company_theme_text", this.eesdesService.set(this.empDetails.empdata.company_theme_text));
                 this.getAccessToken(this.empDetails.empdata.company_id,id);
                //  this.userLogin();
                this.getUserDetailsForDepartment()

              }
            }
            else {
              this.getAccessToken(this.empDetails.empdata.company_id,id);
            }

          } else if (data.status == false) {
            this.toasterService.pop('error', 'Oops', data.message);
            this.isLoading = false;
            return
          }
        }, error => {

        }
      );
  }
  already_active:boolean=false;
  already_active_msg:any=''
  getUserAccessToken(company_id,user_id) {
    let requestObj = {
      "company_id": company_id ? company_id : '0',
      "user_id":user_id?user_id:''
    }
    this.webService.commonPostMethod('User_session_management/generate_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            localStorage.setItem('user_access_token', this.eesdesService.set(data.response));
//             if(this.source_data.type=='MAIL')
// {
//   // window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
//   let url=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
//   this.IsVailidLink(url);
// }
// else
// {
//   this.showIssue(false);
//   if(this.isSocialLogin)
//   {
//     this.webService.redirectURL('/my-companies');
//   }
//   else
//   {
//     this.getCompanySetUpData();
//   }
// }
if(this.responseData.user.role != 'vendor' && !this.is_vendor_login)
{
  sessionStorage.setItem('company_id', this.empDetails.empdata.company_id);
  localStorage.setItem("company_id", this.eesdesService.set(this.empDetails.empdata.company_id));
  localStorage.setItem("emp_role", this.eesdesService.set(this.empDetails.empdata.employee_role));
  localStorage.setItem("company_title", this.eesdesService.set(this.empDetails.empdata.company_title));
  localStorage.setItem("company_code", this.eesdesService.set(this.empDetails.empdata.company_code));

  localStorage.setItem("company_logo", this.eesdesService.set(this.empDetails.empdata.company_logo));
  localStorage.setItem("employee_code", this.eesdesService.set(this.empDetails.empdata.employee_code));
  localStorage.setItem("company_theme", this.eesdesService.set(this.empDetails.empdata.company_theme));
  localStorage.setItem("company_theme_text", this.eesdesService.set(this.empDetails.empdata.company_theme_text));

}
else
{
  sessionStorage.setItem('company_id', this.vendorDetails.vendordata.company_id);
  localStorage.setItem("company_id", this.eesdesService.set(this.vendorDetails.vendordata.company_id));
    localStorage.setItem("emp_role", this.eesdesService.set(this.vendorDetails.vendordata.employee_role));
    localStorage.setItem("ven_role", this.eesdesService.set(this.vendorDetails.vendordata.employee_role));

    localStorage.setItem("company_title", this.eesdesService.set(this.vendorDetails.vendordata.company_title));
    localStorage.setItem("company_code", this.eesdesService.set(this.vendorDetails.vendordata.company_code));

    localStorage.setItem("company_logo", this.eesdesService.set(this.vendorDetails.vendordata.company_logo));
    // console.log('vendor code 2='+this.vendorDetails.vendordata.employee_code)
    localStorage.setItem("employee_code", this.eesdesService.set(this.vendorDetails.vendordata.employee_code));
    localStorage.setItem("company_theme", this.eesdesService.set(this.vendorDetails.vendordata.company_theme));
    localStorage.setItem("company_theme_text", this.eesdesService.set(this.vendorDetails.vendordata.company_theme_text));
}
this.userLogin();
if(this.source_data.type=='MAIL')
{
  // window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
  let url=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
  this.IsVailidLink(url);
}
else
{
  this.showIssue(false);
  if(this.isSocialLogin)
  {
    this.webService.redirectURL('/my-companies');
  }
  else
  {
    this.getCompanySetUpData();
  }
}
if(this.isSSO)
            {
              this.showSSO(false);
            }
          }
          else if(data.already_active)
          {
            this.already_active=true;
            this.already_active_msg=data.message;
            this.showIssue(true);
          }
          else {
            if (this.eesdesService.get('company_id',localStorage.getItem('company_id')) == null || this.eesdesService.get('company_id',localStorage.getItem('company_id')) == "0") {
              if(this.source_data.type=='MAIL')
              {
                // window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
                let url=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
                this.IsVailidLink(url);
              }
              else
              {
                if(this.isSocialLogin)
                {
                  this.webService.redirectURL('/my-companies');
                }
                else
                {
                  this.getCompanySetUpData();
                }
              }

            }
            else {
              this.toasterService.pop("error", "Error", data.message);
              window.localStorage.clear();
              window.sessionStorage.clear()
              window.location.href = "";
            }
          }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  getAccessToken(id,user_id) {
    let requestObj = {
      "company_id": id ? id : '0',
    }
    this.webService.commonPostMethod('Companies/company_get_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this._cookieService.setCompanyAccessToken(data.response);
            localStorage.setItem('access_token', this.eesdesService.set(data.response));
            this.setHttpCookie({"action":"set",
            "cookie_name": "access_token",
            "cookie_value": this.eesdesService.set(data.response,'access_token'),
            "expire": "72000"})
            this.company_data={company_id:id,user_id:user_id};
            this.getUserAccessToken(id,user_id);
            }
            else {
              this.toasterService.pop("error", "Error", data.message);
              window.localStorage.clear();
              window.location.href = "";
            }

        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  vendorDetails: any
  getVendorDetailsOld(vendorId) {
    let requestObj = {
      "vendor_id": vendorId,
    }
    this.webService.commonPostMethod('Vendor_management/ajax_getsingvendor_companies_details', requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            this.vendorDetails = data.response;
            if (this.vendorDetails != undefined && this.vendorDetails != '') {
              if (this.vendorDetails.companies.length > 1) {

if(this.source_data.type=='MAIL')
{
  window.location.href=window.location.origin+"/my-companies?data="+this.source_data.data;

}
else
{
  this.webService.redirectURL('/my-companies');

}

              }
              else {
                if (this.vendorDetails.companies) {
                  for (let i of this.vendorDetails.companies) {
                    localStorage.setItem("employee_code", this.eesdesService.set(i.vendor_code));

                  }
                }
                if(this.source_data.type=='MAIL')
{
  window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;

}
else
{
  this.getCompanySetUpData();
}
              }
            }
            else {
              if (this.vendorDetails.companies) {
                for (let i of this.vendorDetails.companies) {
                  localStorage.setItem("employee_code", this.eesdesService.set(i.vendor_code));

                }
              }
              if(this.source_data.type=='MAIL')
{
  window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;

}
else
{
  this.getCompanySetUpData();
}
            }

          } else if (data.status == false) {
            this.toasterService.pop('error', 'Oops', data.message);
            this.isLoading = false;
            return
          }
        }, error => {
          this.toasterService.pop('error','Error','Something Went Wrong');
        }
      );
  }
  getVendorDetails(id) {
    let requestObj = {
      "vendor_id": id == undefined || id == null ? 0 : id,
      "company_id":'0'
    }
    if(this.isSocialLogin)
    {
      requestObj['social_login']='1'
    }
    //employees/ajax_getsingvendor
    //employees/Vendor_management/ajax_getsingvendor_companies_details
    this.vendorDetails={};
    this.webService.commonPostMethod('Vendor_management/ajax_getsingvendor_companies_details', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.vendorDetails = data;
            if(!Array.isArray(this.vendorDetails.vendordata))
            {
            if (this.vendorDetails.vendordata != undefined && this.vendorDetails.vendordata != '') {


              if (this.vendorDetails.vendordata.companies.length > 1) {
                if(this.source_data.type=='MAIL')
                {
                  let url=window.location.origin+"/#/my-companies?data="+this.source_data.data;
                  this.IsVailidLink(url);

                }
                else
                {
                this.webService.redirectURL('/my-companies')
                }
              }
              else {
                if (this.vendorDetails.vendordata) {
                  if (this.vendorDetails.vendordata.companies) {
                    for (let j of this.vendorDetails.vendordata.companies) {
                      if (j.vendor_id == id) {
                        j.company_setup=j.company_setup?j.company_setup:{'MINUTES_UNITL_AUTO_LOGOUT':10};

                        this.vendorDetails.vendordata.employee_role = this.vendorDetails.vendordata.role?this.vendorDetails.vendordata.role:'';
                        this.vendorDetails.vendordata.employee_code = j.vendor_code;
                        this.vendorDetails.vendordata.company_id = j.company_id;
                        this.vendorDetails.vendordata.company_title = j.company_title;
                        this.vendorDetails.vendordata.company_code = j.company_code?j.company_code:'';

                        this.vendorDetails.vendordata.company_logo = j.company_logo;
                        this.vendorDetails.vendordata.company_theme = j.company_theme ? j.company_theme: '#035168';
                        this.vendorDetails.vendordata.company_theme_text = j.company_theme_text ? j.company_theme_text: '#FFFFFF';
                        this.vendorDetails.vendordata.allow_multiple_login=j.allow_multiple_login?j.allow_multiple_login:'0'
                        j.company_setup = j.company_setup ? j.company_setup : {};
                        // localStorage.setItem("company_setup", JSON.stringify(j.company_setup));
                        j.company_setup.MINUTES_UNITL_AUTO_LOGOUT= j.company_setup.MINUTES_UNITL_AUTO_LOGOUT? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                        localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',j.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
                        j.company_setup.enable_strict_auto_logout_policy = j.company_setup.enable_strict_auto_logout_policy ? j.company_setup.enable_strict_auto_logout_policy : '0';
                        localStorage.setItem('enable_strict_auto_logout_policy',j.company_setup.enable_strict_auto_logout_policy);
                        localStorage.setItem("department_id", this.eesdesService.set(j.department?j.department:''));
                        localStorage.setItem("department_name", this.eesdesService.set(j.department_name?j.department_name:''));
                        localStorage.setItem("profile_image", this.eesdesService.set(j.profile_image?j.profile_image:''));


                      }
                    }
                  }
                }
                // localStorage.setItem("company_id", this.eesdesService.set(this.vendorDetails.vendordata.company_id));
                // localStorage.setItem("emp_role", this.eesdesService.set(this.vendorDetails.vendordata.employee_role));
                // localStorage.setItem("ven_role", this.eesdesService.set(this.vendorDetails.vendordata.employee_role));

                // localStorage.setItem("company_title", this.eesdesService.set(this.vendorDetails.vendordata.company_title));
                // localStorage.setItem("company_code", this.eesdesService.set(this.vendorDetails.vendordata.company_code));

                // localStorage.setItem("company_logo", this.eesdesService.set(this.vendorDetails.vendordata.company_logo));
                // // console.log('vendor code 2='+this.vendorDetails.vendordata.employee_code)
                // localStorage.setItem("employee_code", this.eesdesService.set(this.vendorDetails.vendordata.employee_code));
                // localStorage.setItem("company_theme", this.eesdesService.set(this.vendorDetails.vendordata.company_theme));
                // localStorage.setItem("company_theme_text", this.eesdesService.set(this.vendorDetails.vendordata.company_theme_text));
                 this.getAccessToken(this.vendorDetails.vendordata.company_id,id);
                //  this.userLogin();

              }
              // this.userLogin();
            }
            else {
              this.getAccessToken(this.vendorDetails.vendordata.company_id,id);
            }

        // this.userLogin();

          }
          else
          {
            this.toasterService.pop('error', 'Error','Invalid Login');

            this.isLoading = false;
            return
          }
          } else{
            this.toasterService.pop('error', 'Oops', data.message);
            this.isLoading = false;
            return
          }
        }, error => {

        }
      );
      // // this.userLogin();
  }

  forgotPassword() {
    this.forgotPasswordInput = true;
    this.disableButton = false;
    this.userNewEmail = ""
  }

  goBack() {
    this.forgotPasswordInput = false;
    this.showOtp = false;
  }

  validaeEmail() {
    if (this.userNewEmail == '' || this.userNewEmail == undefined) {
      this.toasterService.pop("error", "Error", "Enter email id");
      return false;
    }
    let host = this.webService.retrnAngularUrl();

    this.isLoading = true;
    let requestObj = {
      "email": this.userNewEmail,
      "url": host + "/#/reset-password",
      "user_type": this.userType ? this.userType : "2"
    }
    this.webService.commonPostMethod('Login_Exe/ajax_forget_pwd', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.toasterService.pop('success', 'Success', "Reset your password by clicking the link shared in your email" + ' ' + this.userNewEmail);
            this.isLoading = false;
            this.userNewEmail = "";
            this.disableButton = false;
          } else {
            this.toasterService.pop('error', 'Error', data.message);
            this.isLoading = false;
            return
          }
        }, error => {

        }
      );
  }
  showPassCode(status)
  {
  this.show=status.toString();
  //console.log(this.show)

  }

  //chanukya added for department details 2019-12-04
  getUserDetailsForDepartment() {
    let requestObj = {
      "company_id":this.empDetails.empdata.company_id ? this.empDetails.empdata.company_id : '',
      "emp_id": this.responseData.user.id ? this.responseData.user.id : '',
    }
    if(this.isSocialLogin)
    {
      requestObj['social_login']='1'
    }
    this.webService.commonPostMethod('employees/ajax_getsingemp', requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            let empDetails:any;
            empDetails = data;
            console.log(empDetails)
            if (empDetails.empdata != undefined && empDetails.empdata != '') {


              if (empDetails.empdata.companies.length > 1) {
                this.webService.redirectURL('/my-companies')


              }
              else {
                if (empDetails.empdata) {
                  if (empDetails.empdata.companies) {
                    for (let j of empDetails.empdata.companies) {
                      if (j.employee_id == this.responseData.user.id) {
                        j.company_setup = j.company_setup ? j.company_setup : {};
                        // localStorage.setItem("company_setup", JSON.stringify(j.company_setup));
                        j.company_setup.MINUTES_UNITL_AUTO_LOGOUT= j.company_setup.MINUTES_UNITL_AUTO_LOGOUT? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                        localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',j.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
                        j.company_setup.enable_strict_auto_logout_policy = j.company_setup.enable_strict_auto_logout_policy ? j.company_setup.enable_strict_auto_logout_policy : '0';
                        localStorage.setItem('enable_strict_auto_logout_policy',j.company_setup.enable_strict_auto_logout_policy);
                        localStorage.setItem("department_id", this.eesdesService.set(j.department?j.department:''));
                        localStorage.setItem("department_name", this.eesdesService.set(j.department_name?j.department_name:''));
                        localStorage.setItem("profile_image", this.eesdesService.set(j.profile_image?j.profile_image:''));


                      }
                    }
                  }
                }


              }
              // this.userLogin();
            }

            else {
            }

          }


        }, error => {

        }
      );
      // this.userLogin();
  }

  showTerms() {
    document.getElementById('termsModal').style.display = "block";
    document.getElementById('body').style.overflow = 'hidden';
  }

  hideTerms() {
    document.getElementById('termsModal').style.display = "none";
    document.getElementById('body').style.overflow = 'auto';
  }

  showPrivacy() {
    document.getElementById('privacyModal').style.display = "block";
    document.getElementById('body').style.overflow = 'hidden';
  }

  hidePrivacy() {
    document.getElementById('privacyModal').style.display = "none";
    document.getElementById('body').style.overflow = 'auto';
  }
  setLoginType()
  {
    this.showOtp = false;
    if(this.isLoading)
    {
      this.toasterService.pop('info','Info','Wait Already Some Process is running');
      return;
    }
    this.is_vendor_login=!this.is_vendor_login;
     this.userType = this.is_vendor_login == false ? '2' : '1';
  }
  IsVailidLink(url)
  {
    let requestObj:any={
      data:this.source_data.data?this.source_data.data:'',
    };
    this.webService.commonPostMethod("Vendor_management/ajax_decrypt_rfq_data", requestObj).
      subscribe(
        data => {
          if (data.status) {
            window.location.href=url;
          }
          else {
            this.toasterService.pop('error','Error',data.message);
            localStorage.clear();
            this.router.navigate(['/']);
          }
        },
        error => {
          this.toasterService.pop('error','Error','Something Went Wrong');
          localStorage.clear();
          this.router.navigate(['/']);
        }
      );
  }
  showIssue(flag: boolean) {
    if (flag) {
      document.getElementById("IssueSidenavUserSession").style.width = "35%";
      document.getElementById("showIssueModelUserSession").style.display = "block";
      document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    } else {
      document.getElementById("IssueSidenavUserSession").style.width = "0";
      document.getElementById("showIssueModelUserSession").style.display = "none";
      document.body.style.backgroundColor = "#f0f0f1";
    }
  }
  showSSO(flag: boolean) {
    console.log('flag='+flag);
    if(document.getElementById("IssueSSOSession")!=null)
    {
    if (flag) {
      window.sessionStorage.clear()
      document.getElementById("IssueSSOSession").style.width = "35%";
      document.getElementById("showSSOModelSession").style.display = "block";
      document.body.style.backgroundColor = "#006287";
    } else {
      document.getElementById("IssueSSOSession").style.width = "0";
      document.getElementById("showSSOModelSession").style.display = "none";
      document.body.style.backgroundColor = "#f0f0f1";
    }
  }
  }
  buttonProgressing:boolean=false
  destroyUserToken() {
    let requestObj = {
      "company_id": this.company_data.company_id ? this.company_data.company_id : '0',
    }
    this.buttonProgressing=true
    this.webService.commonPostMethod('User_session_management/destroy_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.buttonProgressing=false
            this.getUserAccessToken(this.company_data.company_id,this.company_data.user_id);
            }
            else {
              this.buttonProgressing=false
              this.toasterService.pop("error", "Error", data.message);
              window.localStorage.clear();
              window.sessionStorage.clear()
              window.location.href = "";
            }
            this.buttonProgressing=false
        }, error => {
          this.buttonProgressing=false
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  detectMob() {
    let cls:any='sidenav_progress'
    if (( window.innerWidth <= 800 ) && ( window.innerHeight <= 700 ) )
    {
      cls=cls+" sidenav_progressMobile"
    }
    if(!this.already_active)
    {
      cls=''
    }
    return cls
  }
  setHttpCookie(payload) {

    this.webService.commonPostMethod('login/cookies', payload).
      subscribe(
        data => {
          if (data.status) {
            }
            else {
            }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  detectDivMob() {
    let cls:any=''
    if (( window.innerWidth <= 800 ) && ( window.innerHeight <= 700 ) )
    {
      cls=cls+" SSODiv"
    }
    if(!this.isSSO)
    {
      cls=''
    }
    return cls
  }
  msLogin()
  {
    let redirectUrl = '/#';
    let url='/'
    let origin = window.location.origin;
    redirectUrl = origin + '/third-party-login' + redirectUrl + url;
    window.location.href = redirectUrl;
  }
  company_setup: any = {};
  getCompanySetUpData() {
    let req = {
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      variable_list:['redirect_vendor_profile_page','MINUTES_UNITL_AUTO_LOGOUT','enable_strict_auto_logout_policy','landing_url'],
      component:this.constructor.name?this.constructor.name:'',
      "check_ven_pro_acc": this.is_vendor_login ? '1' : '0',
      "has_comp_access": '1',
    }
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany_limited_as_requested", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup={}
          this.company_setup=data.response ? data.response : {}
          this.company_setup.MINUTES_UNITL_AUTO_LOGOUT = this.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? this.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10;
          localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',this.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
          this.company_setup.enable_strict_auto_logout_policy = this.company_setup.enable_strict_auto_logout_policy ? this.company_setup.enable_strict_auto_logout_policy : '0';
          localStorage.setItem('enable_strict_auto_logout_policy',this.company_setup.enable_strict_auto_logout_policy);
          this.company_setup.redirect_vendor_profile_page = this.company_setup.redirect_vendor_profile_page ? this.company_setup.redirect_vendor_profile_page : '0';
          let has_access = data.has_access ? data.has_access : false;

          this.company_setup.landing_url=this.company_setup.landing_url?this.company_setup.landing_url:'1';
          data.has_comp_access = data.has_comp_access ? data.has_comp_access : '0';
          this.company_setup.landing_url = data.has_comp_access=='1' ? this.company_setup.landing_url : '1';

          let navigateToComplianceDashboard = data.has_comp_access=='1' ? true : false;
          
          // let tmpMenu = this.webService.getMenuByUrl('/my-dashboard');

          // if(tmpMenu)
          // {
          //   console.log(tmpMenu);
          //   return;
          // }

          // if(tmpMenu && tmpMenu.submenu && tmpMenu.submenu.length > 0)
          // {
          //   // console.log(tmpMenu);
          //   let tmpObj = tmpMenu.submenu.find(o => o.aurl == '/my-dashboard');
          //   if(tmpObj)
          //   {
          //     navigateToComplianceDashboard = true;              
          //   }
          // }

          if(this.company_setup.landing_url =='2' && navigateToComplianceDashboard){
            window.location.href=window.location.origin+'/compliance/#/my-dashboard';
          } else {
            this.webService.redirectURL('/dashboard');
          }
          if(this.company_setup.redirect_vendor_profile_page=="1" && this.is_vendor_login) {
            if(has_access) {
              this.webService.redirectURL('/vendorprofile');
            } else {
              this.webService.redirectURL('/dashboard');
            }
          } else {
            this.webService.redirectURL('/dashboard');
          }
        }
        else {
          this.toasterService.pop('error', "Error", data.message);
        }
      }, error => {
        this.toasterService.pop("error", "Error", "Something Went Wrong");
      }
    )
  }

  showOtp: boolean = false;
  otp: any = "";
  user_id: any = "";
  verifyOtp() {
    if(this.otp=="") {
      this.toasterService.pop("error", "Error", "Please enter otp to proceed.");
      return false;
    }
    let req:any={
      "user_id": this.user_id,
      "otp": this.otp
    }
    this.webService.commonPostMethod('authorization/validate_otp', req).
      subscribe(
        data => {
          if (data.status) {
            this.otp = "";
            this.setUserVariables();
          } else {
            this.toasterService.pop("error", "Error", data.message);
          }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  arrayForSearch: any = [];
  getModule(url) {
    let temp: any = [];
    temp = this.arrayForSearch.filter((v) => { return v.url == url })
    return temp[0] ? temp[0] : '';
  }
  userLogin() {

    let url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let payload = {
      // company_id" :15,
      //   "url":"login",
      //   "project" : "login",
      //   "module_name" : "login",
      //   "user_id" : 4972 ,
      //   "activity_type" :"login
      // "url": url,
       "project": this.getModule(url).project ? this.getModule(url).project : 'operation',
      // "module_name": this.getModule(url).menuName ? this.getModule(url).menuName : '',
      // "module_id": this.getModule(url).id ? this.getModule(url).id : '',
      "activity_type": 'login',
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
      'user_id': this._localStorageService.getUserId(),
      'user_role_id': this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) ? this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) : '0'
    }
    this.webService.commonPostMethod("User_activity/save_user_activity", payload).
      subscribe(
        data => {
          if (data.status) {
            this.already_active_msg=data.message;

          }

        },
        error => {
        }
      );

  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1872153256/src/src/app/pages/login/login.component.ts